export default "__VITE_ASSET__PCSiFdxl__"